import { Component } from '@angular/core'

@Component({
  selector: 'ai-reconciler',
  templateUrl: './ai-reconciler.component.html',
  styleUrls: ['./ai-reconciler.component.scss'],
})
export class AiReconcilerComponent {}
